import { Button } from '@/components/ui/button';
import { MessageCircle, Phone, X } from 'lucide-react';

interface DealChatHeaderProps {
  contactName: string;
  phoneNumber?: string;
  isConnected?: boolean;
  onClose: () => void;
  onCall?: () => void;
}

export function DealChatHeader({ contactName, phoneNumber, isConnected, onClose, onCall }: DealChatHeaderProps) {
  return (
    <div className="flex-shrink-0">
      {/* Top bar */}
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <div>
          <h3 className="font-semibold text-sm">WhatsApp — {contactName}</h3>
          {phoneNumber && <p className="text-xs text-muted-foreground">{phoneNumber}</p>}
        </div>
        <Button variant="ghost" size="icon" onClick={onClose} className="h-8 w-8">
          <X className="h-4 w-4" />
        </Button>
      </div>
      {/* Sub-header */}
      <div className="flex items-center justify-between px-4 py-2 bg-primary/10 border-b">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
            <MessageCircle className="w-4 h-4 text-primary" />
          </div>
          <div>
            <p className="font-medium text-xs">{phoneNumber}</p>
            <div className="flex items-center gap-1 text-[10px] text-muted-foreground">
              {isConnected && (
                <>
                  <span className="w-1.5 h-1.5 bg-green-500 rounded-full" />
                  online
                </>
              )}
            </div>
          </div>
        </div>
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={onCall} disabled={!phoneNumber}>
          <Phone className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
}
